import React, { useEffect, useState } from 'react';
import { PlaygroundChat } from 'src/components/PlaygroundChat/PlaygroundChat';
import CardContainer from 'src/components/CardContainer/CardContainer';
import { useGetAllConfigurationSettingsQuery } from 'src/services';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { LoaderWrapper } from 'src/components/LoaderWrapper/LoaderWrapper';
import { Skeleton } from 'src/components/ui/skeleton';
import { useAppSelector } from 'src/store';
import { PATH_DASHBOARD } from 'src/constants/spa-routes';
import { API_VERSION } from 'src/constants/api-routes';

export const PlaygroundSection = ({ isFullScreen, fullScreenBtnClickHandler = () => {} }) => {
  const [configSettings, setConfigSettings] = useState(null);
  const { id } = useParams();
  const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;
  const isV2 = version === API_VERSION.V2;

  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const { projectType } = useAppSelector((s) => s.projectsSlices);
  const projectTypeVar = projectType || type;
  const navigate = useNavigate();

  const { data: configurationSettings, isLoading: isLoadingConfigurationSettings } =
    useGetAllConfigurationSettingsQuery(
      { id },
      { skip: !id, refetchOnMountOrArgChange: true },
    ) as any;

  useEffect(() => {
    if (configurationSettings) {
      const deployed = configurationSettings.items.find((settings) => settings.is_deployed);

      if (!deployed || !configurationSettings.items.length) {
        return navigate(
          `${PATH_DASHBOARD.PROJECTS}/${id}/new/${isV2 ? 4 : 3}?type=${projectTypeVar}`,
        );
      }

      setConfigSettings(deployed);
    }
  }, [configurationSettings]);

  const { isInactivePlan } = useAppSelector((s) => s.planSlice);

  return (
    <CardContainer className="flex-1 w-full min-w-1 !h-full items-center relative !bg-[linear-gradient(180deg,#FFF_0%,#F7F6FF_96.35%)] border border-[#7A6BE533]">
      <div className="card-body flex flex-auto w-full h-full overflow-hidden !mt-0">
        <LoaderWrapper
          loader={
            <div className={'w-full h-full flex flex-col gap-5'}>
              <Skeleton className="w-full h-[90%]" />
              <Skeleton className="w-full h-[10%]" />
            </div>
          }
          isLoading={isLoadingConfigurationSettings}
        >
          {configSettings ? (
            <PlaygroundChat
              titleClassName="!text-sm !font-bold !text-[#7A6BE5]"
              disabled={isInactivePlan}
              name={'control_desk_chat'}
              isTitle
              settings={configSettings}
              isFullScreenBtn
              fullScreenBtnClick={fullScreenBtnClickHandler}
              chatContainerClassName={isFullScreen && 'max-w-[70%]'}
              replyContainerClassName={isFullScreen && 'max-w-[70%]'}
            />
          ) : (
            <div
              className={
                'bg-[#F5FCFE] w-full self-start rounded-sm-5 border border-[#009CB240] flex items-center justify-center p-7.5'
              }
            >
              <p className={'text-center text-base font-medium text-[#009CB2]'}>
                Complete all required fields in the Configuration tab to enable the Playground.
              </p>
            </div>
          )}
        </LoaderWrapper>
      </div>
    </CardContainer>
  );
};
